export const mapOverviewSportToTeaserStat = (sport) => {
    if (!sport) { return null; }
    const { matches, rank } = sport;
    return {
        title: 'Matches Played - All Time',
        total: Number(matches?.played) || 0,
        wins: Number(matches?.won) || 0,
        losses: Number(matches?.lost) || 0,
        rankLabel: rank?.label || 'Age Group',
        rank: rank?.value != null ? Number(rank.value) : null,
        rankDisplay: rank?.valueDisplay ?? null,
    };
};
